var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_253_2574",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8105 20.9053L20.9053 -4.46503e-08L-8.93006e-08 20.9053L20.9053 41.8105L41.8105 20.9053Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8105 20.9053L43.2248 19.4911L44.639 20.9053L43.2248 22.3195L41.8105 20.9053ZM40.3963 22.3195L19.4911 1.41421L22.3195 -1.41421L43.2248 19.4911L40.3963 22.3195ZM19.4911 40.3963L40.3963 19.4911L43.2248 22.3195L22.3195 43.2248L19.4911 40.3963Z",
    fill: "#9D9D9D",
    mask: "url(#path-1-inside-1_253_2574)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.7b07a9ca17ec8ff415b782e46f8937ed.svg";
export { ForwardRef as ReactComponent };